import get from "lodash.get"

export const formatArticles = (prismicData) => {
  const { edges } = prismicData

  return edges.map(({ node }) => ({
    id: node.id,
    content: node.data.article.text,
    publishedAt: node.data.published_at,
    url: node.data.link_to_article.url,
    logo: node.data.publisher_logo.url,
    publisherName: node.data.publisher_name.text,
  }))
}
export const formatCases = (prismicData) => {
  return prismicData.nodes.map((node) => ({
    id: node.id,
    quote: node.data.quote.text,
    quoteAuthor: node.data.quote_author?.text,
    slug: `/cases/${node.data.slug}`,
    avatar: node.data.avatar.gatsbyImageData,
    title: node.data.title.text,
    tag: node.data.tag,
  }))
}
export const formatCase = (node) => {
  return {
    id: node.id,
    quote: node.data.quote.text,
    quoteAuthor: node.data.quote_author?.text,
    avatar: node.data.avatar.gatsbyImageData,
    title: node.data.title.text,
    body: node.data.content.richText,
    tag: node.data.tag,
  }
}

export const formatQuestionPairs = (prismicData) => {
  const { edges } = prismicData

  return edges.map(({ node }) => ({
    id: get(node, "data.index"),
    question: get(node, "data.question.text"),
    answer: get(node, "data.answer.richText"),
  }))
}

export const formatLinkedQuestionPairs = (data = []) => {
  return data.map(({ pair }) => ({
    id: get(pair, "document.id"),
    index: get(pair, "document.data.index"),
    question: get(pair, "document.data.question.text"),
    answer: get(pair, "document.data.answer.richText"),
  }))
}

export const formatWebinars = ({ nodes }) =>
  nodes.map((node) => ({
    id: get(node, "id"),
    locale: get(node, "lang"),
    tag: get(node, "data.tag.text"),
    index: get(node, "data.index"),
    key: get(node, "id"),
    title: get(node, "data.title.text"),
    heroImage: get(node, "data.hero_image"),
    summary: get(node, "data.summary.richText"),
    footer: get(node, "data.footer.richText"),
    sections: get(node, "data.sections", []).map((section) =>
      get(section, "description.richText"),
    ),
    time: new Date(get(node, "data.time")),
    end: new Date(get(node, "data.end")),
    price: get(node, "data.price"),
    url: get(node, "data.url.url"),
    speakers: get(node, "data.speakers", []).map((speaker) => ({
      name: get(speaker, "name"),
      photo: get(speaker, "photo"),
      alt: get(speaker, "photo.alt"),
      description: get(speaker, "speaker_description.richText"),
      subject: get(speaker, "speaker_subject.richText"),
    })),
    highlights: get(node, "data.highlights", []).map((word) => word.text),
    duration: get(node, "data.duration"),
    language: get(node, "data.language"),
    audience: get(node, "data.audience", "teachers"),
    faqs: formatLinkedQuestionPairs(get(node, "data.faqs")),
    showLiveLink: get(node, "data.show_live_link") !== false,
    showLunchOption: get(node, "data.show_lunch_option") !== false,
    attendanceType: get(node, "data.attendance_type"),
  }))

export const filterWebinars = (webinars, showAll, locale) => {
  const upcomingWebinars = locale
    ? webinars.filter((w) => w.end >= new Date() && w.locale === locale)
    : webinars.filter((w) => w.end >= new Date())
  const pastWebinars = locale
    ? webinars.filter((w) => w.end < new Date() && w.locale === locale)
    : webinars.filter((w) => w.end < new Date())

  if (upcomingWebinars.length >= 5) {
    return showAll ? upcomingWebinars : upcomingWebinars.slice(0, 5)
  }
  return showAll
    ? [...upcomingWebinars, ...pastWebinars.slice(upcomingWebinars.length - 10)]
    : [...upcomingWebinars, ...pastWebinars.slice(upcomingWebinars.length - 5)]
}

export const formatTestimonial = (data) => ({
  id: get(data, "id"),
  key: get(data, "id"),
  title: get(data, "title.text"),
  text: get(data, "text.richText"),
  person_name: get(data, "person_name.text"),
  person_description: get(data, "person_description.text"),
  logo: get(data, "logo.url"),
  logo_alt: get(data, "logo.alt"),
  fact_large: get(data, "fact_large.text"),
  fact_small: get(data, "fact_small.text"),
})
